<template>
  <el-dialog
    :visible.sync="visibleProxy"
    title="Test thông báo giới hạn học sinh"
    width="680px"
    :close-on-click-modal="false"
    append-to-body
    custom-class="ps-dialog"
  >
    <div v-if="schoolRow" class="ps-school-context">
      <div class="ps-school-avatar"><i class="el-icon-school" /></div>
      <div>
        <strong>{{ schoolRow.school.name }}</strong>
        <span>
          {{ schoolRow.school.id }} ·
          {{ schoolRow.currentStudents | formatNumber }} học sinh đang học ·
          {{ schoolRow.package ? schoolRow.package.code : "Chưa gán gói" }}
        </span>
      </div>
    </div>

    <div v-if="schoolRow && schoolRow.assignment" class="ps-alert-test-overview">
      <div class="ps-alert-test-overview__item">
        <span>Giới hạn hiệu lực</span>
        <strong>{{ schoolRow.effectiveLimit | formatNumber }} HS</strong>
      </div>
      <div class="ps-alert-test-overview__item">
        <span>Đang sử dụng</span>
        <strong>{{ formatPercent(schoolRow.usagePercent) }}%</strong>
      </div>
      <div class="ps-alert-test-overview__item">
        <span>Trạng thái hiện tại</span>
        <el-tag :type="schoolRow.locked ? (schoolRow.allowExceedStudentLimit ? 'warning' : 'danger') : 'success'" size="mini" effect="light">
          {{ schoolRow.locked
            ? (schoolRow.allowExceedStudentLimit ? "Đã đạt/vượt giới hạn · vẫn cho phép thêm" : "Đã đầy · chặn thêm")
            : "Còn số lượng" }}
        </el-tag>
      </div>
    </div>

    <el-alert
      v-if="!schoolRow || !schoolRow.assignment"
      type="warning"
      :closable="false"
      show-icon
      title="Trường chưa có gói đang áp dụng nên không thể test cảnh báo."
    />

    <el-alert
      v-else
      class="ps-dialog-alert"
      type="info"
      :closable="false"
      show-icon
      title="API sẽ tính lại số học sinh, kiểm tra ngưỡng cảnh báo và gửi thử qua Firebase tới các tài khoản trường đã bật nhận thông báo. Quyền vượt giới hạn không thay đổi số liệu hoặc cảnh báo."
    />

    <div v-if="result" class="ps-alert-test-result">
      <el-alert
        :type="result.sent ? 'success' : (result.shouldAlert ? 'warning' : 'info')"
        :closable="false"
        show-icon
        :title="result.message || 'Đã nhận kết quả test từ API'"
      />

      <div class="ps-alert-test-metrics">
        <div class="ps-alert-test-metric">
          <span>Tỷ lệ sử dụng</span>
          <strong>{{ formatPercent(result.usageRatio * 100) }}%</strong>
        </div>
        <div class="ps-alert-test-metric">
          <span>Ngưỡng cấu hình</span>
          <strong>{{ formatPercent(result.thresholdRatio * 100) }}%</strong>
        </div>
        <div class="ps-alert-test-metric">
          <span>Ngưỡng số lượng còn lại</span>
          <strong>≤ {{ result.remainingSlotsConfig | formatNumber }}</strong>
        </div>
        <div class="ps-alert-test-metric">
          <span>Trạng thái theo trường</span>
          <strong :class="result.notifyEnabled ? 'is-success' : 'is-danger'">
            {{ result.notifyEnabled ? "Đang bật" : "Đang tắt" }}
          </strong>
        </div>
        <div class="ps-alert-test-metric">
          <span>Số chỗ còn lại</span>
          <strong :class="{ 'is-danger': result.overLimit }">
            {{ result.remaining | formatNumber }}
          </strong>
        </div>
        <div class="ps-alert-test-metric">
          <span>Tài khoản nhận</span>
          <strong>{{ result.deliveredReceiverCount || 0 }}/{{ result.receiverCount || 0 }}</strong>
        </div>
        <div class="ps-alert-test-metric">
          <span>Token thành công</span>
          <strong class="is-success">{{ result.successfulTokenCount || 0 }}</strong>
        </div>
        <div class="ps-alert-test-metric">
          <span>Token thất bại</span>
          <strong :class="{ 'is-danger': result.failedTokenCount > 0 }">
            {{ result.failedTokenCount || 0 }}
          </strong>
        </div>
      </div>

      <div v-if="result.title || result.body" class="ps-alert-test-preview">
        <span class="ps-alert-test-preview__label">Nội dung thông báo</span>
        <strong>{{ result.title }}</strong>
        <p>{{ result.body }}</p>
      </div>
    </div>

    <span slot="footer" class="ps-dialog-footer">
      <el-button @click="visibleProxy = false">Đóng</el-button>
      <el-button
        v-if="schoolRow && schoolRow.assignment"
        type="primary"
        :loading="loading"
        @click="$emit('send', schoolRow.school.id)"
      >
        <i class="el-icon-bell" /> {{ result ? "Gửi lại test" : "Gửi test Firebase" }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "PackageLimitAlertTestDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    schoolRow: {
      type: Object,
      default: null,
    },
    result: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    visibleProxy: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
  },
  methods: {
    formatPercent(value) {
      return Number(value || 0).toFixed(1);
    },
  },
};
</script>
